import { useContext } from "react";
import { decisionsContext } from "../../../containers/Features";
import V1 from "./__variants__/v1";
import V2 from "./__variants__/v2";

const ProductLink = props => {
  const experimentName = "emf-553_plp_selling_fast";
  const experiments = useContext(decisionsContext);

  const Component = experiments?.[experimentName]?.bucket === "v2" ? V2 : V1;

  return <Component {...props} />;
};

export default ProductLink;
